/* @flow */
import {GENERIC_EVENT, trigger as edapTrigger} from './edapWrapper';
import type {EdapData} from './edapWrapper';
import {getFilterId} from './filters';

export const triggerSelectUnselectFilterEdapEvent = (eventObj: EdapData) => {
    edapTrigger(GENERIC_EVENT, eventObj);
};

export const triggerEdapEventForCheckbox = (
    event: SyntheticEvent<HTMLInputElement>
) => {
    let filterId = getFilterId(event);
    let eventaction = `filter ${
        event.currentTarget.checked ? '' : 'un'
    }selected`;

    if (event.currentTarget.checked) {
        if (filterId) {
            triggerSelectUnselectFilterEdapEvent({
                eventaction,
                eventlabel: filterId
            });
        }
    } else {
        triggerSelectUnselectFilterEdapEvent({eventaction});
    }
};
